import { configureStore }           from '@reduxjs/toolkit';
import provider                     from './reducers/provider';

const store = configureStore({
    reducer: {
        provider: provider.reducer
    }
})

export default store